module.exports = __webpack_public_path__ + "img/logo-rm.215ff75b.png";